import type {
  PartnerSearchTagsParams,
  PartnerTag,
  PartnerTagCreate,
  PartnerTagUpdate,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const tags = {
  search: {
    queryKey: 'partner-management-service/tags',
    configurationType: 'default' as const,
    fn: async (params: PartnerSearchTagsParams = {}) => {
      const { data } = await GatewayAxiosClient.get<PartnerTag[]>('/partner-management-proxy/api/v1/partners/tags', {
        params,
      });

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/tags/id',
    configurationType: 'no-cache' as const,
    fn: async (tagId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerTag>(
        `/partner-management-proxy/api/v1/partners/tags/${tagId}`,
      );

      return data;
    },
  },
  create: async (tag: PartnerTagCreate) => {
    const { data } = await GatewayAxiosClient.post<PartnerTag>('/partner-management-proxy/api/v1/partners/tags', tag);

    return { data, invalidateQueryKeys: [['partner-management-service/tags']] };
  },
  update: async ({ tagId, payload }: { tagId: string; payload: PartnerTagUpdate }) => {
    const { data } = await GatewayAxiosClient.put<PartnerTag>(
      `/partner-management-proxy/api/v1/partners/tags/${tagId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [['partner-management-service/tags'], ['partner-management-service/tags/id', tagId]],
    };
  },
};
